export default function () {
    new Swiper(".about__swiper", {
        slidesPerView: 1,
        spaceBetween: 24,
        loop:true,
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                
            },
        },
        navigation: {
            nextEl: ".about__swiper__btn.next",
            prevEl: ".about__swiper__btn.prev",
        },
        on: {
            init: function () {
                setSlideHeightsToMax(this);
            },
            resize: function () {
                setSlideHeightsToMax(this);
            }
        }
    });

    function setSlideHeightsToMax(swiper) {
        const slides = swiper.slides;
        let maxHeight = 0;
        let paddingAddition = 48;

        slides.forEach(slide => {
            const content = slide.querySelector('.about__team-member');
            if (content) {
                content.style.height = ''; // Reset height before recalculating
                const contentHeight = content.clientHeight+paddingAddition;
                maxHeight = Math.max(maxHeight, contentHeight);
            }
        });

        slides.forEach(slide => {
            const content = slide.querySelector('.about__team-member');
            if (content) {
                content.style.height = maxHeight + 'px';
            }
        });
    }
}